// components/OrderConfirmation.js
import React from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import "../styles/orderconf.css";
import Navbar from "./common/Navbar.jsx";
import Footer from "./common/Footer.jsx";

const OrderConfirmation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { orderId, orderCode, total, paymentMethod } = location.state || {};

  React.useEffect(() => {
    if (!orderId) {
      navigate("/market");
    }
  }, [orderId, navigate]);

  if (!orderId) {
    return (
      <div>
        <Navbar />
        <div className="order-confirmation-container">
          <div className="error-message">
            <h2>Order Not Found</h2>
            <p>Redirecting you to the marketplace...</p>
          </div>
        </div>
      </div>
    );
  }

  const getPaymentInstructions = (method) => {
    switch (method) {
      case "lumicash":
        return {
          image: "../images/lumicash.png",
          title: " LUMICASH Payment",
          instructions: "Make a Deposit with LUMICASH ",
          account: "Code: 50877",
          name: " Ndacayisaba Elyse",
        };
      case "bancobu":
        return {
          image: "../images/bancobu.jpg",
          title: "BANCOBU",
          instructions: "Transfer to our bancobu bank account:",
          account: "Bancobu: 16151940401",
          name: " iblotec",
        };
      case "bancobu-enoti":
        return {
          image: "../images/enoti.png",
          title: "BANCOBU Enoti",
          instructions: "Transfer to our Enoti account:",
          account: "Bancobu Enoti: 89034",
          name: " iblotec",
        };
      case "coopec":
        return {
          image: "../images/coopec.png",
          title: " COOPEC",
          instructions: "Transfer to our COOPEC account:",
          account: "Coopec: 57676",
          name: " iblotec",
        };
      case "ihela":
        return {
          image: "../images/ihela.png",
          title: "iHela Ryanje",
          instructions: "Transfer to our iHela account:",
          account: "iHela: 97704-01",
          name: " iblotec",
        };

      case "cash":
      default:
        return {
          title: "Pay Cash",
          instructions:
            "Make the Payment at IBloTec Office when your order is ready",
          account: "",
          name: "",
        };
    }
  };

  const paymentInfo = getPaymentInstructions(paymentMethod);

  return (
    <div>
      <Navbar />
      <div className="order-confirmation-container">
        <div className="confirmation-card">
          <div className="confirmation-header">
            <div className="success-icon">
              <svg viewBox="0 0 100 100" className="checkmark">
                <circle
                  cx="50"
                  cy="50"
                  r="45"
                  fill="none"
                  stroke="#4caf50"
                  strokeWidth="5"
                />
                <path
                  fill="none"
                  stroke="#4caf50"
                  strokeWidth="8"
                  d="M30,50 L45,65 L70,35"
                  className="checkmark-check"
                />
              </svg>
            </div>
            <h1>Order Confirmed!</h1>
            <p className="order-number">Order Code: {orderCode}</p>
            <p className="order-id">Order #: {orderId}</p>
          </div>

          <div className="confirmation-details">
            <div className="detail-section">
              <h3>Order Summary</h3>
              <div className="detail-row">
                <span>Order Number:</span>
                <span>{orderCode}</span>
              </div>
              <div className="detail-row">
                <span>Total Amount:</span>
                <span className="total-amount">
                  {total?.toLocaleString()} Fbu
                </span>
              </div>
              <div className="detail-row">
                <span>Payment Method:</span>
                <span>{paymentMethod?.replace("_", " ").toUpperCase()}</span>
              </div>
              <div className="detail-row">
                <span>Order Status:</span>
                <span className="status-badge pending">Processing</span>
              </div>
            </div>

            {paymentMethod !== "cash" && (
              <div className="detail-section payment-instructions">
                <h3>Payment Instructions</h3>
                <div className="payment-info">
                  <div className="payment-info-top">
                    <img
                      src={paymentInfo.image}
                      alt={paymentInfo.title}
                      className="payment-method-image"
                    />
                    <h4 className="Blue1">{paymentInfo.title}</h4>
                  </div>

                  <p className="Blue2">{paymentInfo.instructions}</p>
                  {paymentInfo.account && (
                    <p className="account-info">
                      <strong>Account:</strong>
                      <strong className="Blue1">{paymentInfo.account}</strong>
                    </p>
                  )}
                  <p>
                    Account Name{" "}
                    <strong className="Blue1">{paymentInfo.name}</strong>
                  </p>
                  <p className="important-note Blue2">
                    <i className="fa-solid fa-circle-exclamation Blue2"></i>
                    Please include your order code{" "}
                    <strong className="Blue1">{orderCode}</strong> in the
                    payment motif
                  </p>
                </div>
              </div>
            )}

            <div className="detail-section">
              <h3>Next Steps</h3>
              <div className="process-steps">
                {paymentMethod !== "cash" && (
                  <div className="process-step">
                    <div className="step-number">1</div>
                    <div className="step-content">
                      <h4>Make Payment</h4>
                      <p>Complete your payment using the instructions above</p>
                    </div>
                  </div>
                )}
                <div className="process-step">
                  <div className="step-number">
                    {paymentMethod !== "cash" ? "2" : "1"}
                  </div>
                  <div className="step-content">
                    <h4>Upload Payment Proof</h4>
                    <p>
                      After payment, upload your proof in "My Orders" section
                    </p>
                  </div>
                </div>
                <div className="process-step">
                  <div className="step-number">
                    {paymentMethod !== "cash" ? "3" : "2"}
                  </div>
                  <div className="success-icon"></div>
                  <div className="step-content">
                    <h4>Order Processing</h4>
                    <p>We'll process your order once payment is verified</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="confirmation-actions">
            <Link to="/my-orders" className="btn btn-primary">
              <i className="fa-solid fa-receipt"></i> View My Orders
            </Link>
            <Link to="/market" className="btn btn-secondary">
              <i className="fa-solid fa-bag-shopping"></i> Continue Shopping
            </Link>
            {paymentMethod !== "cash" && (
              <Link
                to={`/upload-payment/${orderId}`}
                className="btn btn-warning"
              >
                <i className="fa-solid fa-upload"></i> Upload Payment Proof
              </Link>
            )}
          </div>

          <div className="confirmation-footer">
            <p>
              {paymentMethod !== "cash"
                ? "Please upload your payment proof within 24 hours to avoid order cancellation"
                : "Your order will be processed and delivered soon"}
            </p>
            <p className="thank-you-message">
              Thank you for shopping with IBloTec! 🤗🎉
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default OrderConfirmation;
